// Horizontal note spacing, reverse-engineered from Guitar Pro 8.
//
// libGPIO's am::music::Spacing::relativeSpacing(NoteValue) is a lookup table
// indexed by note value, scaled by a global density factor of 0.87. Values are
// in staff-spaces. The table is deliberately *sub-linear* in duration (a
// quarter is 2x an eighth in time but only ~1.39x in width) and floors past
// 32nd notes — this compression is what makes spacing look engraved rather
// than mechanically stretched. See SPEC.md §3.

import { RhythmValue } from './rhythm';

/** Raw table indexed by RhythmValue (Longa..TwoFiftySixth), in staff-spaces. */
export const RAW_SPACING: readonly number[] = [
  5.511, // Longa
  5.511, // Breve
  5.511, // Whole
  5.5945, // Half
  4.5925, // Quarter
  3.3066, // Eighth
  2.7555, // Sixteenth
  2.2044, // ThirtySecond
  2.2044, // SixtyFourth
  2.2044, // OneTwentyEighth
  2.2044, // TwoFiftySixth
];

/** Global density factor (GP applies 0.87 to every table lookup). */
export const DENSITY = 0.87;

/**
 * Minimum horizontal advance for a note of the given value, in staff-spaces.
 * Dots and accidentals add to this in the spacing pass; this is the base.
 */
export function relativeSpacing(value: RhythmValue): number {
  const raw = RAW_SPACING[value];
  if (raw === undefined) {
    throw new Error(`relativeSpacing: no entry for RhythmValue ${value}`);
  }
  return raw * DENSITY;
}
